module.exports = __webpack_public_path__ + "media/images/icons/vendors/accessories-0b8c08f25c4f00ea4a4625a84ad09b5c.png";